import {
  Home, Search, FileText, Gavel, ScrollText, Wallet, Users, Clock, Calendar, Vote,
  UsersRound, Hourglass, Hotel, Store, KeyRound, Pill, Receipt, PackageCheck, Radio,
  Image as ImageIcon, BookOpen, PenSquare, Trophy, Layers, ClipboardList,
} from 'lucide-react'

// Single source of truth for dashboard navigation. The sidebar, the mobile
// drawer, the command palette and the Home quick links all read from here, so a
// page can't be linked from one place and missing (or mis-pathed) in another.
// Access is still decided by canAccessPage() in AuthContext.
export const STAFF_NAV = [
  {
    title: 'Overview',
    items: [
      { path: '/staff', label: 'Home', icon: Home, desc: 'Server status and what needs attention' },
    ],
  },
  {
    title: 'Players',
    items: [
      { path: '/staff/reports', label: 'Reports', icon: FileText, desc: 'In-game player reports and sits' },
      { path: '/staff/player-lookup', label: 'Player Lookup', icon: Search, desc: 'Characters, inventory, notes, reports and bans' },
      { path: '/staff/punishment-history', label: 'Punishments', icon: ScrollText, desc: 'Warnings, kicks and bans by player' },
      { path: '/staff/bans-manager', label: 'Bans', icon: Gavel, desc: 'Search, edit and lift bans' },
      { path: '/staff/player-reimbursement', label: 'Reimbursements', icon: Wallet, desc: 'Restore cash, bank and items' },
    ],
  },
  {
    title: 'Staff',
    items: [
      { path: '/staff/staff-roster', label: 'Roster', icon: Users, desc: 'Every staff member, rank and record' },
      { path: '/staff/staff-hours', label: 'Hours', icon: Clock, desc: 'On-duty time by staff member' },
      { path: '/staff/staff-loa', label: 'Leave of Absence', icon: Calendar, desc: 'Who is away and until when', feature: 'staffLoa' },
      { path: '/staff/staff-vote', label: 'Votes', icon: Vote, desc: 'Staff recognition votes' },
    ],
  },
  {
    title: 'City',
    items: [
      { path: '/staff/gang-roster', label: 'Gangs', icon: UsersRound, desc: 'Gang roster, tiers and strikes' },
      { path: '/staff/gang-cooldown', label: 'Gang Cooldowns', icon: Hourglass, desc: 'Players blocked from rejoining gangs' },
      { path: '/staff/radio-locks', label: 'Radio Locks', icon: Radio, desc: 'Private radio channels', feature: 'radioLocks' },
      { path: '/staff/apartments', label: 'Apartments', icon: Hotel, desc: 'Apartment ownership and security' },
      { path: '/staff/business-hours', label: 'Business Hours', icon: Store, desc: 'Employee activity per business' },
      { path: '/staff/realtor', label: 'Realtor', icon: KeyRound, desc: 'Property sales log' },
      { path: '/staff/premium-drug-logs', label: 'Premium Drugs', icon: Pill, desc: 'Custom drug records' },
    ],
  },
  {
    title: 'Store',
    items: [
      { path: '/staff/tebex-transactions', label: 'Tebex Payments', icon: Receipt, desc: 'Look up store purchases' },
      { path: '/staff/imports-log', label: 'Imports', icon: PackageCheck, desc: 'Custom vehicle and clothing imports', feature: 'importsLog' },
    ],
  },
  {
    title: 'Admin',
    items: [
      { path: '/staff/content', label: 'Rules Editor', icon: PenSquare, desc: 'Edit the public rules pages' },
      { path: '/staff/documentation', label: 'Staff Docs', icon: BookOpen, desc: 'Guides and procedures' },
      { path: '/staff/activity', label: 'Activity', icon: ClipboardList, desc: 'Who changed what, and when' },
      { path: '/staff/assets', label: 'Media Assets', icon: ImageIcon, desc: 'Permanent image hosting' },
      { path: '/staff/awards', label: 'Awards', icon: Trophy, desc: 'Community awards', feature: 'awards' },
      { path: '/staff/resource-swiper', label: 'Resource Swiper', icon: Layers, desc: 'One-off resource review', feature: 'resourceSwiper' },
    ],
  },
]

export const ALL_NAV_ITEMS = STAFF_NAV.flatMap((s) => s.items)

export function findNavItem(pathname) {
  let best = null
  for (const item of ALL_NAV_ITEMS) {
    for (const p of [item.path, item.alias].filter(Boolean)) {
      if (p === '/staff' ? pathname === '/staff' : pathname === p || pathname.startsWith(p + '/')) {
        if (!best || p.length > best.matched.length) best = { item, matched: p }
      }
    }
  }
  return best?.item || null
}
